import React from "react";
import { motion, MotionValue } from "framer-motion";

interface AnimatedLogoProps {
    className?: string;
    outerRotation: MotionValue<number>;
    innerRotation: MotionValue<number>;
}

const AnimatedLogo: React.FC<AnimatedLogoProps> = ({ className, outerRotation, innerRotation }) => {
    return (
        <svg 
            width="166" 
            height="175" 
            viewBox="0 0 166 175" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Inner moon parts - rotates counter-clockwise */}
            <motion.g
                style={{ 
                    originX: "50%", 
                    originY: "50%",
                    rotate: innerRotation 
                }}
            >
                {/* Main crescent/moon shape */}
                <path 
                    fillRule="evenodd" 
                    clipRule="evenodd" 
                    d="M61.6622 109.651C76.7608 125.507 101.24 125.507 116.339 109.651C124.549 101.029 128.295 89.4932 127.576 78.2127C130.35 93.2686 126.186 109.456 115.083 121.115C97.3171 139.773 68.5124 139.773 50.7462 121.115C32.98 102.457 32.98 72.2071 50.7462 53.5493C61.8481 41.8902 77.2605 37.5167 91.5961 40.4289C80.8554 39.6746 69.872 43.6084 61.6622 52.2302C46.5636 68.0865 46.5636 93.7948 61.6622 109.651Z" 
                    fill="white"
                />
                {/* Inner circle details */}
                <path 
                    fillRule="evenodd" 
                    clipRule="evenodd" 
                    d="M73.4478 97.2739C81.664 105.902 94.9851 105.902 103.201 97.2739C111.418 88.6454 111.418 74.6557 103.201 66.0272C94.9851 57.3986 81.664 57.3986 73.4478 66.0272C65.2316 74.6557 65.2316 88.6454 73.4478 97.2739ZM88.6446 75.7281C91.7839 79.025 96.8739 79.025 100.013 75.7281C103.153 72.4311 103.153 67.0858 100.013 63.7889C96.8739 60.492 91.7839 60.492 88.6446 63.7889C85.5052 67.0858 85.5052 72.4311 88.6446 75.7281Z" 
                    fill="white"
                />
            </motion.g>

            {/* Outer petals - rotates clockwise */}
            <motion.g
                style={{ 
                    originX: "50%", 
                    originY: "50%",
                    rotate: outerRotation 
                }}
            >
                {/* Top petal */}
                <path 
                    d="M100.242 18.2928C114.396 25.0647 118.162 39.8136 118.276 46.3416C114.45 41.4397 102.005 31.6357 82.8236 31.6357C63.6427 31.6357 51.3335 41.4397 47.5766 46.3416C49.1021 38.0202 52.0773 24.1743 65.405 18.2928C78.2469 12.6256 81.4347 5.06936 82.8236 0L82.8386 0.0523763C84.3382 5.27863 86.1359 11.5434 100.242 18.2928Z" 
                    fill="white"
                />
                {/* Bottom petal */}
                <path 
                    d="M65.6099 155.883C51.4565 149.111 47.6905 134.362 47.5766 127.834C51.4019 132.736 63.8476 142.54 83.0285 142.54C102.209 142.54 114.519 132.736 118.276 127.834C116.75 136.156 113.775 150.001 100.447 155.883C87.6052 161.55 84.4174 169.106 83.0285 174.176L83.0135 174.123C81.5139 168.897 79.7162 162.632 65.6099 155.883Z" 
                    fill="white"
                />
                {/* Left petal */}
                <path 
                    d="M17.4186 68.9028C23.8669 54.039 37.911 50.0839 44.127 49.9644C39.4593 53.9816 30.1239 67.052 30.1239 87.1955C30.1239 107.339 39.4593 120.266 44.127 124.211C36.2033 122.609 23.0191 119.485 17.4186 105.488C12.0222 92.0018 4.82711 88.6541 1.5407e-06 87.1955L0.0498706 87.1797C5.02637 85.6048 10.9918 83.717 17.4186 68.9028Z" 
                    fill="white"
                />
                {/* Right petal */}
                <path 
                    d="M148.434 105.273C141.985 120.137 127.941 124.092 121.725 124.211C126.393 120.194 135.728 107.124 135.728 86.9803C135.728 66.8367 126.393 53.9099 121.725 49.9644C129.649 51.5665 142.833 54.6909 148.434 68.6875C153.83 82.1739 161.025 85.5216 165.852 86.9803L165.802 86.9961C160.826 88.5709 154.86 90.4588 148.434 105.273Z" 
                    fill="white"
                />
            </motion.g>
        </svg>
    );
};

export default AnimatedLogo;